export const isWebEnvironment = (): boolean => {
  return typeof chrome === 'undefined' || !chrome?.runtime?.id
}

export const isExtensionEnvironment = (): boolean => {
  return !isWebEnvironment()
}